// ssl-check.service.ts
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SslCheckService {
  private readonly http = inject(HttpClient);
  private readonly backendUrl = 'https://51.103.210.249/ssl-fingerprint';
  private readonly expectedFingerprint =
    'CA:62:8C:80:87:39:44:21:D2:8E:70:73:D6:35:D7:DC:9E:4E:C9:6D:D9:C7:3E:E2:F1:34:13:D0:65:36:2C:27';

  async isSslDecryptionActive(host: string): Promise<boolean> {
    try {
      const result = await firstValueFrom(
        this.http.get<{ fingerprint?: string; error?: string }>(`${this.backendUrl}?host=${host}`)
      );
      if (result.error) {
        console.error('Backend error:', result.error);
        return false;
      }
      if (!result.fingerprint) {
        return false;
      }
      console.log('Observed fingerprint:', result.fingerprint);
      return result.fingerprint.replace(/:/g, '') !== this.expectedFingerprint.replace(/:/g, '');
    } catch (err) {
      console.error('Network/TLS error:', err);
      return false;
    }
  }
}
